module.exports = __webpack_public_path__ + "img/januca-2015.7405fa60.jpeg";